import { FC, useContext } from 'react'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'

import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useModal } from '../../../../../components'
import { EnderecoList } from '../../../empresa/empresas-list/core/_models'
import { getEnderecosDaOrigem, isOrigemEndereco } from './_origem'

// O endpoint devolve a lista inteira (sem paginação): poucos endereços por origem.
const QueryResponseContext = createResponseContext<EnderecoList[]>(initialQueryResponse)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { origem, id } = useParams<{ origem: string; id: string }>()

  const habilitado = isOrigemEndereco(origem) && !!id && !isOpen

  const {
    isFetching,
    isError,
    refetch,
    data: responseSemPaginacao,
  } = useQuery(
    [QUERIES.ENDERECOS_LIST, origem, id, isOpen],
    () => getEnderecosDaOrigem(origem as 'instituicao' | 'entidade' | 'unidade', Number(id)),
    {
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      // Enquanto o modal está aberto a busca fica parada; ao fechar, o react-query refaz a
      // consulta e a listagem já aparece com o endereço criado/alterado.
      enabled: habilitado,
    }
  )

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, responseSemPaginacao, query: '' }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
